import { render, staticRenderFns } from "./Activity2.vue?vue&type=template&id=1df9966e&scoped=true"
import script from "./Activity2.vue?vue&type=script&lang=js"
export * from "./Activity2.vue?vue&type=script&lang=js"
import style0 from "./Activity2.vue?vue&type=style&index=0&id=1df9966e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df9966e",
  null
  
)

export default component.exports